export default __webpack_public_path__ + "static/typography-image-d-0f5552edaa12daf018f0f1237da8a04b.png";